import { IGetEmployeeByIdParams, IResponse, ISapProduct, ISapProductDto, ISapProductPreview, ISapProductResponseData, ISapProductUpdateDto } from "../../../types"
import { sapApi } from "../../interceptor"

const createProductFormData = (dto: ISapProductDto): FormData => {
  const formData = new FormData()

  formData.append("employee_id", dto.employee_id)
  formData.append("fullname", dto.fullname)
  if (dto.level) formData.append("level", dto.level)
  if (dto.department) formData.append("department", dto.department)
  if (dto.type_of_request) formData.append("type_of_request", dto.type_of_request)
  formData.append("file", dto.file)

  return formData
}

export const sapProductsService = {
  getMasterProducts: async (params: IGetEmployeeByIdParams): Promise<IResponse<ISapProductResponseData>> => {
    const response = await sapApi.get<IResponse<ISapProductResponseData>>("/api/v1/products/history", { params })
    return response.data
  },

  getMasterProductByRecordId: async (recordId: string): Promise<IResponse<ISapProduct>> => {
    const response = await sapApi.get<IResponse<ISapProduct>>(`/api/v1/products/${recordId}`)
    return response.data
  },

  updateMasterProduct: async (recordId: string, dto: ISapProductUpdateDto): Promise<IResponse<ISapProduct>> => {
    const response = await sapApi.patch<IResponse<ISapProduct>>(`/api/v1/products/${recordId}`, dto)
    return response.data
  },

  createMasterProduct: async (dto: ISapProductDto): Promise<ISapProduct> => {
    const formData = createProductFormData(dto)

    const response = await sapApi.post<ISapProduct>("/api/v1/products", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    return response.data
  },

  previewProduct: async (file: File): Promise<ISapProductPreview> => {
    const formData = new FormData()
    formData.append("file", file)

    const response = await sapApi.post<ISapProductPreview>("/api/v1/products/upload", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    return response.data
  },
}
